// Location data for DC, Maryland, and Virginia (Northern Virginia focus)

export const DC_WARDS = [
  { value: '1', label: 'Ward 1' },
  { value: '2', label: 'Ward 2' },
  { value: '3', label: 'Ward 3' },
  { value: '4', label: 'Ward 4' },
  { value: '5', label: 'Ward 5' },
  { value: '6', label: 'Ward 6' },
  { value: '7', label: 'Ward 7' },
  { value: '8', label: 'Ward 8' },
];

export const VIRGINIA_CITIES = [
  { value: '', label: 'Select City' },
  { value: 'Alexandria', label: 'Alexandria' },
  { value: 'Arlington', label: 'Arlington' },
  { value: 'Fairfax City', label: 'Fairfax City' },
  { value: 'Falls Church', label: 'Falls Church' },
  { value: 'Manassas', label: 'Manassas' },
  { value: 'Manassas Park', label: 'Manassas Park' },
  { value: 'Vienna', label: 'Vienna' },
  { value: 'Herndon', label: 'Herndon' },
  { value: 'Leesburg', label: 'Leesburg' },
  { value: 'Reston', label: 'Reston' },
  { value: 'McLean', label: 'McLean' },
  { value: 'Tysons', label: 'Tysons' },
  { value: 'Centreville', label: 'Centreville' },
  { value: 'Chantilly', label: 'Chantilly' },
  { value: 'Springfield', label: 'Springfield' },
  { value: 'Burke', label: 'Burke' },
  { value: 'Annandale', label: 'Annandale' },
  { value: 'Woodbridge', label: 'Woodbridge' },
  { value: 'Dale City', label: 'Dale City' },
  { value: 'Dumfries', label: 'Dumfries' },
  { value: 'Ashburn', label: 'Ashburn' },
  { value: 'Sterling', label: 'Sterling' },
  { value: 'Other', label: 'Other' },
];

export const VIRGINIA_COUNTIES = [
  { value: '', label: 'Select County' },
  { value: 'Arlington County', label: 'Arlington County' },
  { value: 'Fairfax County', label: 'Fairfax County' },
  { value: 'Loudoun County', label: 'Loudoun County' },
  { value: 'Prince William County', label: 'Prince William County' },
  { value: 'Stafford County', label: 'Stafford County' },
  { value: 'Spotsylvania County', label: 'Spotsylvania County' },
  { value: 'Fauquier County', label: 'Fauquier County' },
  { value: 'Other', label: 'Other' },
];

export const MARYLAND_CITIES = [
  { value: '', label: 'Select City' },
  { value: 'Bethesda', label: 'Bethesda' },
  { value: 'Silver Spring', label: 'Silver Spring' },
  { value: 'Rockville', label: 'Rockville' },
  { value: 'Gaithersburg', label: 'Gaithersburg' },
  { value: 'Germantown', label: 'Germantown' },
  { value: 'Bowie', label: 'Bowie' },
  { value: 'College Park', label: 'College Park' },
  { value: 'Greenbelt', label: 'Greenbelt' },
  { value: 'Hyattsville', label: 'Hyattsville' },
  { value: 'Laurel', label: 'Laurel' },
  { value: 'Takoma Park', label: 'Takoma Park' },
  { value: 'Upper Marlboro', label: 'Upper Marlboro' },
  { value: 'Landover', label: 'Landover' },
  { value: 'Oxon Hill', label: 'Oxon Hill' },
  { value: 'Temple Hills', label: 'Temple Hills' },
  { value: 'Suitland', label: 'Suitland' },
  { value: 'Capitol Heights', label: 'Capitol Heights' },
  { value: 'Fort Washington', label: 'Fort Washington' },
  { value: 'Clinton', label: 'Clinton' },
  { value: 'Waldorf', label: 'Waldorf' },
  { value: 'La Plata', label: 'La Plata' },
  { value: 'Annapolis', label: 'Annapolis' },
  { value: 'Glen Burnie', label: 'Glen Burnie' },
  { value: 'Columbia', label: 'Columbia' },
  { value: 'Ellicott City', label: 'Ellicott City' },
  { value: 'Other', label: 'Other' },
];

export const MARYLAND_COUNTIES = [
  { value: '', label: 'Select County' },
  { value: "Prince George's County", label: "Prince George's County" },
  { value: 'Montgomery County', label: 'Montgomery County' },
  { value: 'Charles County', label: 'Charles County' },
  { value: 'Anne Arundel County', label: 'Anne Arundel County' },
  { value: 'Howard County', label: 'Howard County' },
  { value: 'Frederick County', label: 'Frederick County' },
  { value: 'Calvert County', label: 'Calvert County' },
  { value: 'St. Mary\'s County', label: 'St. Mary\'s County' },
  { value: 'Other', label: 'Other' },
];

// Helper function to get location detail based on selection
export const getLocationDetail = (locationType, ward, city, county) => {
  if (locationType === 'DC Ward' && ward) {
    return `Ward ${ward}`;
  } else if ((locationType === 'Virginia' || locationType === 'Maryland') && city) {
    return city;
  }
  return '';
};
